import React, { useState } from "react";
import { FloatButton, Button } from "antd";
import AIChatBox from "./AIChatBox";
import "./AIChatLauncher.css";

const PANEL_WIDTH = 680;
const PANEL_MAX_HEIGHT = "65vh";

export default function AIChatLauncher() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div
          style={{
            position: "fixed",
            bottom: 88,
            right: 24,
            width: PANEL_WIDTH,
            maxHeight: PANEL_MAX_HEIGHT,
            zIndex: 1001,
            boxShadow: "0 6px 24px rgba(0,0,0,0.18)",
            borderRadius: 8,
            background: "#fff",
          }}
        >
          <AIChatBox
            style={{ width: "100%", margin: 0, border: "none", height: "65vh", display: "flex", flexDirection: "column" }}
            bodyStyle={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              padding: "12px 16px",
            }}
            extra={
              <Button
                type="text"
                size="small"
                onClick={() => setOpen(false)}
                aria-label="Close assistant"
              >
                ×
              </Button>
            }
          />
        </div>
      )}
      <FloatButton
        type="primary"
        description="RIA"
        tooltip="Registration Intelligence Assistant"
        className="ai-chat-float-btn"
        style={{ right: 24, bottom: 24, zIndex: 1000, width: 56, height: 56, fontSize: 13 }}
        onClick={() => setOpen((o) => !o)}
      />
    </>
  );
}
